import { generateUUID } from './chat';
import store from '@/store';
import { addMessageListenerToConnection } from './socket';
import sseManager from './sseManager';

const socketUrl = 'wss://rt{0}.dating.com/{1}?client-id={2}'; // 0: shard, 1: token, 2: client-id可用uuid

// 定时重连管理
let reconnectTimer = null;
let userList = []; // 保存用户列表用于重连{id, name, token, ...}
let vueInstance = null; // 保存Vue实例用于触发事件

// 设置Vue实例
const setVueInstance = (instance) => {
  vueInstance = instance;
};

// 批量为用户创建Socket连接
const createSocketsForUsers = async (users) => {
  // console.log('为所有用户创建Socket连接:', users);
  // 注意：不在此处清理已存在连接，因为default连接可能比此函数先创建，会被误清理

  // 保存用户列表用于定时重连
  userList = users;

  // 开启定时重连（如果还没开启）
  startPeriodicReconnect();

  // 所有请求立即并发启动，不等待任何结果
  users.forEach((user) => {
    createSingleSocketConnection(user); // 批量创建Socket连接
  });
};

// 为单个用户创建Socket连接
const createSingleSocketConnection = (user) => {
  const { id, name, token: userToken } = user;
  getTokenForUser(id, userToken)
    .then((token) => {
      console.log('token', token);
      // 如果有token和shard，则创建Socket连接
      if (token && token.key && token.shard) {
        const uuid = generateUUID();
        const finalSocketUrl = socketUrl
          .replace('{0}', token.shard)
          .replace('{1}', token.key)
          .replace('{2}', uuid);

        // console.log(`用户 ${name}: ${id} 创建Socket:`, finalSocketUrl);

        // 创建WebSocket连接并立即添加监听器
        store
          .dispatch('socket/createConnectionInfo', {
            info: {
              ...user,
              datingToken: token.key,
              datingShard: token.shard,
            },
            url: finalSocketUrl,
          })
          .then(() => {
            // console.log(`用户 ${name}: ${id} Socket创建成功，开启消息监听`);
            // 立即添加消息监听器
            addMessageListenerToConnection(id, (message) => {
              handleSocketMessage(id, name, message);
            });
          })
          .catch((error) => {
            // console.error(`用户 ${name}: ${id} Socket创建失败:`, error);
          });
      }
    })
    .catch((error) => {
      // console.error(`用户 ${name}: ${id} 获取token失败:`, error);
    });
};

// 开启定时重连（每5分钟）
const startPeriodicReconnect = () => {
  return;
  // 如果已经有定时器在运行，先清除
  if (reconnectTimer) {
    clearInterval(reconnectTimer);
  }

  console.log('开启定时重连机制，每5分钟重连一次');

  reconnectTimer = setInterval(() => {
    console.log('执行定时重连，重新获取token并重连所有Socket');
    reconnectAllSockets();
  }, 5 * 60 * 1000); // 5分钟 = 5 * 60 * 1000毫秒
};

// 重连所有Socket连接
const reconnectAllSockets = () => {
  if (userList.length === 0) {
    // console.log('没有需要重连的用户');
    return;
  }

  // console.log(`开始重连 ${userList.length} 个用户的Socket连接`);

  userList.forEach((user) => {
    const { id, name, token } = user;
    // 重新获取token并重连
    getTokenForUser(id, token)
      .then((token) => {
        if (token && token.key && token.shard) {
          const uuid = generateUUID();
          const newSocketUrl = socketUrl
            .replace('{0}', token.shard)
            .replace('{1}', token.key)
            .replace('{2}', uuid);

          // console.log(`用户 ${name}: ${id} 使用新token重连Socket:`, newSocketUrl);

          // 更新连接信息中的URL
          const connectionObj = store.state.socket.connections[id];
          if (connectionObj) {
            connectionObj.info.url = newSocketUrl;
          }

          // 执行重连
          store
            .dispatch('socket/reconnectConnection', id)
            .then(() => {
              // console.log(`用户 ${name}: ${id} 定时重连成功`);
              // 重新添加消息监听器
              addMessageListenerToConnection(id, (message) => {
                handleSocketMessage(id, name, message);
              });
            })
            .catch((error) => {
              // console.error(`用户 ${name}: ${id} 定时重连失败:`, error);
            });
        }
      })
      .catch((error) => {
        // console.error(`用户 ${name}: ${id} 重连时获取token失败:`, error);
      });
  });
};

// 停止定时重连
const stopPeriodicReconnect = () => {
  if (reconnectTimer) {
    clearInterval(reconnectTimer);
    reconnectTimer = null;
    // console.log('已停止定时重连机制');
  }
};

// 清理所有socket连接和相关资源
const clearAllConnections = () => {
  // console.log('清理所有socket连接和相关资源');

  return new Promise((resolve) => {
    // 停止定时重连
    stopPeriodicReconnect();

    // 清空用户列表
    userList = [];

    // 清空Vue实例引用
    vueInstance = null;

    // 获取所有连接ID
    const connectionIds = store.getters['socket/getAllConnectionIds'];

    if (connectionIds.length === 0) {
      // console.log('没有需要清理的socket连接');
      resolve();
      return;
    }

    // console.log(`开始清理 ${connectionIds.length} 个socket连接`);
    // console.log('清理的连接ID:', connectionIds);

    let closedCount = 0;
    const totalConnections = connectionIds.length;

    // 为每个连接添加关闭监听器
    connectionIds.forEach((id) => {
      const connection = store.getters['socket/getConnection'](id);
      if (connection) {
        // 添加一次性的close监听器
        const closeHandler = () => {
          closedCount++;
          // console.log(`Socket ${id} 已关闭 (${closedCount}/${totalConnections})`);

          // 移除监听器避免内存泄漏
          connection.off('close', closeHandler);

          // 所有连接都关闭后resolve
          if (closedCount >= totalConnections) {
            // console.log('所有socket连接已完全关闭');
            resolve();
          }
        };

        connection.on('close', closeHandler);

        // 如果连接已经是关闭状态，直接计数
        if (!connection.connected) {
          setTimeout(() => closeHandler(), 0);
        }
      } else {
        // 连接不存在，直接计数
        closedCount++;
        if (closedCount >= totalConnections) {
          resolve();
        }
      }
    });

    // 通过store清空所有socket连接（这会触发close事件）
    store.dispatch('socket/closeAllConnections');

    // 设置超时保护，避免无限等待
    setTimeout(() => {
      if (closedCount < totalConnections) {
        // console.warn(`清理超时，强制完成。已关闭: ${closedCount}/${totalConnections}`);
      }
      resolve();
    }, 3000); // 3秒超时
  });
};

// 处理WebSocket消息 - 触发回调
const handleSocketMessage = (id, name, message) => {
  // console.log('收到socket消息:', name, message.type);

  // 通过 sseManager 处理 socket 消息，确保未读消息数量更新
  try {
    sseManager.handleSocketMessage(message);
  } catch (error) {
    console.error('通过sseManager处理socket消息失败:', error);
  }

  // 使用保存的Vue实例触发事件
  if (vueInstance && vueInstance.$root) {
    vueInstance.$root.$emit('dating-socket-message', {
      connectionId: id,
      message,
    });
  } else {
    // console.warn('Vue实例不可用，无法触发dating-socket-message事件');
  }
};

/**
 * 为单个用户获取token
 * @param {string} userId
 * @returns {Promise<{key: string, shard: string}>}
 */
const getTokenForUser = (userId, token) => {
  const baseUrl = process.env.VUE_APP_BASE_API_DT2;

  return fetch(`${baseUrl}/shards/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}"`,
    },
  })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error(`获取token失败: ${response.status}`);
      }
    })
    .then((data) => {
      // console.log(`用户 ${userId} 获取token:`, data);
      return data;
    });
};

export {
  createSocketsForUsers,
  startPeriodicReconnect,
  stopPeriodicReconnect,
  reconnectAllSockets,
  setVueInstance,
  clearAllConnections,
};
